import type { LineMeasurementPoint } from '../../model/screencast-tooltips/screencastLineMeasurementResolver';

import styles from './ScreencastTooltip.module.scss';

const LINE_WIDTH = 2;
const CROSS_HALF_SIZE = 6;
const CROSS_WIDTH = 2;
const MIN_SCALE = 0.01;

type LineMeasurementOverlayProps = {
  imageNaturalWidth: number;
  imageNaturalHeight: number;
  start: LineMeasurementPoint;
  end: LineMeasurementPoint;
  scale: number;
};

// eslint-disable-next-line mobx/missing-observer
export const LineMeasurementOverlay = ({
  imageNaturalWidth,
  imageNaturalHeight,
  start,
  end,
  scale,
}: LineMeasurementOverlayProps) => {
  if (imageNaturalWidth <= 0 || imageNaturalHeight <= 0) {
    return null;
  }

  const safeScale = Math.max(scale, MIN_SCALE);
  const lineWidth = LINE_WIDTH / safeScale;
  const crossHalfSize = CROSS_HALF_SIZE / safeScale;
  const crossWidth = CROSS_WIDTH / safeScale;

  return (
    <svg
      aria-hidden
      className={styles.LineMeasurementOverlay}
      viewBox={`0 0 ${imageNaturalWidth} ${imageNaturalHeight}`}
      preserveAspectRatio="none"
    >
      <line
        className={styles.LineMeasurementLine}
        x1={start.x}
        y1={start.y}
        x2={end.x}
        y2={end.y}
        strokeWidth={lineWidth}
      />
      {[start, end].map((point, index) => (
        <g key={index}>
          {renderLineMeasurementCross({
            className: styles.LineMeasurementCross,
            x: point.x,
            y: point.y,
            halfSize: crossHalfSize,
            strokeWidth: crossWidth,
          })}
        </g>
      ))}
    </svg>
  );
};

function renderLineMeasurementCross({
  className,
  x,
  y,
  halfSize,
  strokeWidth,
}: {
  className: string;
  x: number;
  y: number;
  halfSize: number;
  strokeWidth: number;
}) {
  return (
    <>
      <line className={className} x1={x - halfSize} y1={y} x2={x + halfSize} y2={y} strokeWidth={strokeWidth} />
      <line className={className} x1={x} y1={y + halfSize} x2={x} y2={y - halfSize} strokeWidth={strokeWidth} />
    </>
  );
}
